<template>
    <main-layout />
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";

export default {
    name: "Home",
    components: {
        MainLayout
    }
};
</script>
